import './App.css';
import Shoes from './Shoesmart1/mart/Shoes';

function App() {

  return (
    <div className="App">
      <Shoes />
    </div>
  );
}

export default App;
